<script setup lang="ts">
import { RouterView } from 'vue-router';
import VerticalHeaderVue from './vertical-header/VerticalHeader.vue';
import FooterPanel from './footer/FooterPanel.vue';
</script>

<template>
  <v-locale-provider>
    <v-app theme="PurpleTheme">
      <VerticalHeaderVue />
      <v-main>
        <v-container fluid class="page-wrapper">
          <div>
            <RouterView />
          </div>
        </v-container>
        <FooterPanel />
      </v-main>
    </v-app>
  </v-locale-provider>
</template>
